module.exports = __webpack_public_path__ + "img/minus.6c68a929.svg";